import { combineReducers } from "@reduxjs/toolkit";
import { AuthReducer } from "./auth/Reducers";
import { AutorizacionReducer } from "./autorizacion/Reducers";
import { MedicamentoReducer } from "./medicamento/Reducers";
import { AseguradoReducer } from "./asegurado/Reducers";
import { AfiliadoFarmaCardReducer } from "./afiliadoFarmaCard/Reducers";
import { PrestadorReducer } from "./prestador/Reducers";
import { ProcedimientoReducer } from "./procedimiento/Reducers";
import { PrecertificacionReducer } from "./precertificacion/Reducers";
import { CatalogoReducer } from "./catalogo/Reducers";
import { VoucherReducer } from "./voucher/Reducers";
import { ConfiguracionReducer } from "./configuracion/Reducers";
import { EgresosReducer } from "./hospitalizacion/egresos/Reducers";

import { HojasQuirurgicasReducer } from "./hospitalizacion/hojasQuirurgicas/Reducers";
import { OrdsInfoplanReducer } from "./ordsInfoplan/Reducers";

const appReducer = combineReducers({
  auth: AuthReducer,
  autorizacion: AutorizacionReducer,
  medicamento: MedicamentoReducer,
  asegurado: AseguradoReducer,
  afiliadoFarmaCard: AfiliadoFarmaCardReducer,
  prestador: PrestadorReducer,
  procedimiento: ProcedimientoReducer,
  precertificacion: PrecertificacionReducer,
  catalogo: CatalogoReducer,
  voucher: VoucherReducer,
  configuracion: ConfiguracionReducer,
  egreso: EgresosReducer,
  hospitalizacion: HojasQuirurgicasReducer,
  ordsInfoplan: OrdsInfoplanReducer,
});

const rootReducer = (state, action) => {
  return appReducer(state, action);
};

export default rootReducer;